import { gql } from "@apollo/client";

export const GET_EMPLOYER_JOB_ADS_AWAITING_REVIEW = gql`
  query GetEmployerJobAdsAwaitingReview {
    getEmployerJobAdsAwaitingReview {
      id
      organization {
        name
      }
      title
      status
      principal {
        name
      }
      createdAt
    }
  }
`;

export const ADMIN_ACTIVATE_EMPLOYER_JOB_AD = gql`
  mutation AdminActivateEmployerJobAd($id: String!) {
    adminActivateEmployerJobAd(id: $id) {
      status
    }
  }
`;

export const ADMIN_REJECT_EMPLOYER_JOB_AD = gql`
  mutation AdminRejectEmployerJobAd($id: String!) {
    adminRejectEmployerJobAd(id: $id) {
      status
    }
  }
`;

export const ADMIN_GET_ALL_EMPLOYER_JOB_ADS = gql`
  query AdminGetAllEmployerJobAds(
    $first: Int
    $after: String
    $statuses: [EmployerJobAdStatus!]
    $employmentTypes: [EmploymentType!]
    $organizationIds: [String!]
    $principalIds: [String!]
    $dateFrom: DateTimeISO
    $dateTo: DateTimeISO
  ) {
    adminGetAllEmployerJobAds(
      first: $first
      after: $after
      statuses: $statuses
      employmentTypes: $employmentTypes
      organizationIds: $organizationIds
      principalIds: $principalIds
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      edges {
        cursor
        node {
          id
          title
          description
          status
          employmentType
          duration {
            value
            type
          }
          salaryDetails {
            starting
            cap
            currency
            currencyCode
          }
          location {
            area
            state
            country
          }
          tags {
            id
            name
          }
          organization {
            id
            name
          }
          principal {
            id
            name
          }
          createdAt
          updatedAt
        }
      }
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GET_EMPLOYER_JOB_AD = gql`
  query GetEmployerJobAd($id: String!) {
    getEmployerJobAd(id: $id) {
      id
      title
      description
      status
      employmentType
      duration {
        value
        type
      }
      salaryDetails {
        starting
        cap
        currencyCode
      }
      tags {
        id
        name
      }
      organization {
        name
      }
      principal {
        name
      }
      thirdParty {
        name
      }
      createdAt
    }
  }
`;
